export default __webpack_public_path__ + "static/media/howto2.b7058f70.png";